export default __webpack_public_path__ + "static/media/25.37e7d6d1.jpg";